import type { IconSvgObject } from './types';

const SortingNineOneIcon: IconSvgObject = [
  ["path", { d: "M8.5 21H5.5M7 21V14H6.5L5.5 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 6.5V3H5V6.5H9ZM9 6.5V10H5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 17L17 20L20 17M17 4V19.3912", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SortingNineOneIcon;
